"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { AuthProvider } from "@/hooks/useAuth";
import { SessionProvider } from "@/hooks/useSession";
import { ToastProvider } from "@/components/ui/Toast";
import { NotificationServiceWorkerBridge } from "@/components/layout/NotificationServiceWorkerBridge";
import { InstallPromptProvider } from "@/components/install/InstallPromptProvider";

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <InstallPromptProvider>
          <ToastProvider>
            <SessionProvider>
              <NotificationServiceWorkerBridge />
              {children}
            </SessionProvider>
          </ToastProvider>
        </InstallPromptProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
